import Typography from '@mui/material/Typography';
import { Column } from 'components/Layout';
import {
  HoldingClassRealisations,
  InvestorAllocationTotals,
} from '../../types';
import PerInvestorAllocationTable from '../../AllocationTables/PerInvestorAllocationTable';
import PerClassAllocationTable from '../../AllocationTables/PerClassAllocationTable';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { Divider } from 'further-ui/components/Layout';

type Props = {
  currency: CurrencyCode;
  holdingClassRealisations: HoldingClassRealisations;
  investorAllocationsTotals: Array<InvestorAllocationTotals>;
};

const ConsiderationOverview: React.FC<Props> = ({
  currency,
  holdingClassRealisations,
  investorAllocationsTotals,
}) => {
  return (
    <>
      <Column spacing="sm" fullWidth>
        <Typography variant="h5">Per class allocation</Typography>
        <PerClassAllocationTable
          holdingClassRealisations={holdingClassRealisations}
          currency={currency}
        />
      </Column>
      <Divider />
      <Column spacing="sm" fullWidth>
        <Typography variant="h5">Per investor allocation</Typography>
        <PerInvestorAllocationTable
          currency={currency}
          investorAllocationsTotals={investorAllocationsTotals}
        />
      </Column>
    </>
  );
};

export default ConsiderationOverview;
